// this needs to be one of the first things that happens when the app starts up to
// let webpack know how to resolve dependencies for static assets and dynamic imports
// eslint-disable-next-line no-undef
__webpack_public_path__ = window.webpackPublicPath
